// extracted by mini-css-extract-plugin
export default {"order-container":"Order_order-container__QPQDR","order-card":"Order_order-card__GL794"};